/* eslint-disable no-param-reassign */
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  GeneratedRound,
  OptionValue,
  Metadata,
  RoundMetaData,
  RoundState,
} from 'packages/common-types/base-types';
import {Result, Standing} from 'packages/common-types/schema-types';
import {RootState} from 'redux/store';

// Define the initial state using that type
const initialState: RoundState = {
  loadedRound: null,
  generatedRound: null,
  standings: null,
  selectedRound: {
    label: 'Selecciona una ronda',
    value: '',
  },
  metadata: {
    idTournament: '',
    currentRound: 0,
    nextRound: 0,
    saved: false,
  },
};

export const counterSlice = createSlice({
  name: 'round',
  initialState,
  reducers: {
    // New actions
    setSelectedRound: (state, action: PayloadAction<OptionValue>) => {
      state.selectedRound = action.payload;
    },
    setRoundMetadataKey: (state, action: PayloadAction<Metadata>) => {
      const {key, value} = action.payload;
      state.metadata = {
        ...state.metadata,
        [key]: value,
      };
    },
    setRoundMetadata: (state, action: PayloadAction<RoundMetaData>) => {
      state.metadata = action.payload;
    },
    setGeneratedRound: (state, action: PayloadAction<GeneratedRound>) => {
      state.generatedRound = action.payload;
    },
    setLoadedRound: (state, action: PayloadAction<Result[]>) => {
      state.loadedRound = action.payload;
    },
    setStandings: (state, action: PayloadAction<Standing>) => {
      state.standings = action.payload;
    },
  },
});

export const {
  setGeneratedRound,
  setSelectedRound,
  setRoundMetadataKey,
  setLoadedRound,
  setRoundMetadata,
  setStandings,
} = counterSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectGeneratedRound = (state: RootState) =>
  state.round.generatedRound;

export const selectSelectedRound = (state: RootState) =>
  state.round.selectedRound;

export const selectRoundMetadata = (state: RootState) => state.round.metadata;

export const selectLoadedRound = (state: RootState) => state.round.loadedRound;

export const selectStandings = (state: RootState) => state.round.standings;

export default counterSlice.reducer;
